import React from "react"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import * as timecardHelper from "../../helpers/timecardHelper"
import { ITimecardDay, IPayrollStatusDocument, ITimecardPriorPeriodData, ELoggedInUserType } from "../../models"
import * as colorHelper from "../../helpers/colorHelper"

interface IProps {
	userId: string
	timecardDays: ITimecardDay[]
	lockData: IPayrollStatusDocument[]
	timecardPriorPeriodData: ITimecardPriorPeriodData
	priorPeriodAdjustMode: boolean
	allowPriorPeriodAdjust: boolean
	loggedInUserType: ELoggedInUserType
}

const EmployeeTimecardTotalAmountsRow: React.SFC<IProps> = (props: IProps) => {
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	return (
		<TableRow className="EmployeeTimecardTotalAmountsRow">
			{props.timecardDays.map((timecardDay, i) => {
				const locked = timecardHelper.timecardDayLocked(props.userId, timecardDay.LocalStartDayTime, props.lockData, props.priorPeriodAdjustMode, props.allowPriorPeriodAdjust)
				const color = colorHelper.getTotalsRowTextColor(props.timecardPriorPeriodData)

				return (
					<TableRowColumn
						key={i}
						style={{ backgroundColor: locked ? "#EFEFEF" : "white", verticalAlign: "top" }}
					>
						<table style={{ width: "100%", paddingTop: 10, paddingBottom: 10, color: color }}>
							<tbody>
								<tr key="payTotal">
									<td>Pay:</td>
									<td>{formatter.format(timecardDay.PayTotal)}</td>
								</tr>
								{props.loggedInUserType !== ELoggedInUserType.Employee && [
									<tr key="burdenTotal">
										<td>Burden:</td>
										<td>{formatter.format(timecardDay.BurdenTotal)}</td>
									</tr>,
									<tr key="billTotal">
										<td>Bill:</td>
										<td>{formatter.format(timecardDay.BillTotal)}</td>
									</tr>,
									<tr key="netTotal">
										<td>Net:</td>
										<td>{formatter.format(timecardDay.NetTotal)}</td>
									</tr>,
									<tr key="marginTotal">
										<td>Margin:</td>
										<td>{timecardDay.MarginTotal}%</td>
									</tr>
								]}
							</tbody>
						</table>
					</TableRowColumn>
				)
			})}
		</TableRow>
	)
}

export default EmployeeTimecardTotalAmountsRow
